"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BannerSection_1 = __importDefault(require("../../components/BannerSection/BannerSection"));
var HelpSection_1 = __importDefault(require("../../components/HelpSection/HelpSection"));
var Tour3DSection_1 = __importDefault(require("../../components/Tour3DSection"));
var AppFooter_1 = __importDefault(require("../../components/AppFooter/AppFooter"));
var RoomTourBanner_1 = __importDefault(require("../../components/RoomTourBanner"));
var Home = function () {
    react_1.useEffect(function () {
        window.scroll(0, 0);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "home-page" },
            react_1.default.createElement("section", { id: "banner" },
                react_1.default.createElement(BannerSection_1.default, null)),
            react_1.default.createElement("section", { id: "how-help" },
                react_1.default.createElement(HelpSection_1.default, null)),
            react_1.default.createElement("section", null,
                react_1.default.createElement(RoomTourBanner_1.default, null)),
            react_1.default.createElement("section", null,
                react_1.default.createElement(Tour3DSection_1.default, null))),
        react_1.default.createElement(AppFooter_1.default, { layout: "HOME" })));
};
exports.default = Home;
